import React from 'react'

export default ({ to }) => {
  if (typeof window !== 'undefined') {
    window.location.href = to
  }
  return null
}
